<template>
<div>
	<confirm-container>
		<div slot-scope="{info}" slot="recognizeInfo">
			<RecognizeInfoForPerson :info="info" v-if="type=='person'"/>
			<RecognizeInfoForCar :info="info" v-if="type=='car'"/>
		</div>
		<template slot="agree">
			<a href="/static/pdf/haierProduct/平安雇主责任保险（A款）条款.pdf" target="_blank">《平安雇主责任保险（A款）条款》</a>
			<a href="/static/pdf/haierProduct/平安雇主责任保险附加24小时意外保险（A款）.pdf" target="_blank">《平安雇主责任保险附加24小时意外保险（A款）》</a>
			<a href="/static/pdf/haierProduct/平安雇主责任保险附加及时报案保险.pdf" target="_blank">《平安雇主责任保险附加及时报案保险》</a>
			<a href="/static/pdf/haierProduct/平安雇主责任保险附加伤残赔偿比例特约保险（B款）条款.pdf" target="_blank">《平安雇主责任保险附加伤残赔偿比例特约保险（B款）条款》</a>
			<a href="/static/pdf/haierProduct/平安雇主责任保险附加上、下班途中责任保险.pdf" target="_blank" v-if="type=='person'">《平安雇主责任保险附加上、下班途中责任保险》</a>
		</template>
	</confirm-container>
</div>
</template>
<script>
import ConfirmContainer from '@/pages/haierProduct/components/common/ConfirmContainer'
import RecognizeInfoForPerson from './person/RecognizeInfo'
import RecognizeInfoForCar from './car/RecognizeInfo'
export default {
	components:{ 
		ConfirmContainer,
		RecognizeInfoForPerson,
		RecognizeInfoForCar
	},
	data () {
		return {
			type:this.$route.params.type||''
		}
	},
	created(){
	},
	methods:{
		
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
		font-size: 25px;
		line-height: 1.8;
	}
	span.price{
		color:#FF0000;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/Confirm.vue